import axios from 'axios';
import i18n from 'i18next';

const handleGetAcceptLanguage = url => {
  if (url === 'api/services' && i18n.language === 'cn') {
    return 'cn';
  }

  if (url !== 'api/services' && i18n.language === 'cn') {
    return 'en';
  }

  return i18n.language;
};

const api = axios.create({
  baseURL: '/openapi',
});

api.interceptors.request.use(
  config => {
    const newConfig = { ...config };
    newConfig.headers = {
      ...newConfig.headers,
      'Accept-Language': handleGetAcceptLanguage(config.url),
    };
    return newConfig;
  },
  error => {
    return Promise.reject(error);
  },
);

export default api;
